<div class="title mb-4">
  <h2>MANAGE SURVEY</h2>
</div>

<div class="row">
  <div class="col-lg-12 col-md-12">
    <div class="white_box shadow p-3">
      <!-- Table -->
      <section>
        <div class="btn-group mb-3">
          <button class="btn btn-primary" (click)="openAddSurveyModal(modalAddSurvey)">
            <i class="fa-solid fa-plus"></i> Add Survey
          </button>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">
                Question
              </th>
              <th scope="col">
                Type
              </th>
              <th scope="col">
                Option
              </th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of dataFiles; let index  = index">
              <th scope="row">{{ index + 1 }}</th>
              <td>
                <a style="color: black" hre>{{ row.question }}</a>
              </td>
              <td>
                <a style="color: black" hre>{{ row.type }}</a>
              </td>
              <td>
                <a style="color: black" hre>{{ row.option }}</a>
              </td>
              <td>
                <div class="btn-group">
                  <button class="btn btn-secondary btn-sm" (click)="openAddSurveyModal(modalAddSurvey, row)">
                    <i class="fa-solid fa-pen"></i>
                  </button>
                  <button class="btn btn-danger btn-sm" (click)="handleDelete(row)">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>

            <tr *ngIf="dataFiles.length == 0">
              <td colspan="12" style="text-align: center">No Data</td>
            </tr>
          </tbody>
        </table>
      </section>
      <!-- Table -->
    </div>
  </div>
</div>


<ng-template #modalAddSurvey let-modal>
  <div class="modal-content">
    <div class=""></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12 d-flex">
          <div class="ml-auto">
            <h3>Add New Survey</h3>
          </div>
          <div class="ml-auto">
            <i (click)="modalService.dismissAll()" class="fa fa-window-close pointer" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      <div class="col-md-12 mx-auto">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="">Question</label>
              <textarea name="" id="" cols="10" rows="2" class="form-control" placeholder="Question"
                [(ngModel)]="survey.question"></textarea>
            </div>
            <div class="form-group">
              <label for="">Type</label>
              <select name="" id="" class="form-control" [(ngModel)]="survey.type">
                <option value="text">Text</option>
                <option value="checkbox">Checkbox</option>
                <option value="radio">Radio</option>
              </select>
            </div>
            <ng-container *ngIf="survey.type != 'text'">
              <div class="form-group">
                <label for="">Option</label>
                <div class="mb-2 d-flex gap-2" *ngFor="let option of survey.option; let index = index">
                  <input type="text" class="form-control" placeholder="Option {{ index + 1 }}"
                    [(ngModel)]="option.value">
                  <button class="btn btn-danger btn-sm" (click)="survey.option.splice(index, 1)">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>
              <button class="btn btn-sm btn-primary" (click)="survey.option.push({})">
                <i class="fa-solid fa-plus"></i> Add Option
              </button>
            </ng-container>

            <div class="d-flex justify-content-center" style="padding: 4px; width: 100%">
              <button (click)="addSurvey()" class="btn btn-success">
                <i class="fa-solid fa-save"></i> Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>